/*
  Samurai Home — homepage motion
  - Locomotive Scroll v5 (Lenis, native scroll): smooth wheel + photo parallax
  - Anime.js: category reveal, gallery photo transitions
  Depends on sh-vendor.js (window.SHVendor). Safe to load more than once.
*/
(function () {
  'use strict';
  if (window.SHShowroom) return;

  var html = document.documentElement;
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var loco = null;

  // Anything that scrolls on its own inside a drawer, modal or popover keeps native wheel scrolling.
  var PREVENT =
    'dialog, [role="dialog"], [aria-modal="true"], [data-lenis-prevent], ' +
    'x-drawer, x-modal, x-popover, cart-drawer, predictive-search, .drawer, .popover, .modal';

  function vendor() {
    if (window.SHVendor) return window.SHVendor;
    if (window.anime && window.locomotiveScroll) return { anime: window.anime, LocomotiveScroll: window.locomotiveScroll };
    return null;
  }
  function reduced() { return reduceMQ.matches; }
  function pauseScroll(on) {
    var l = loco && loco.lenisInstance;
    if (l) { if (on) l.stop(); else l.start(); }
  }

  /* ---------------- Smooth scroll + parallax ---------------- */

  function initScroll() {
    var V = vendor();
    if (loco || !V) return;

    var flag = document.querySelector('[data-sh-smooth]');
    var smooth = !reduced() && !designMode && (!flag || flag.getAttribute('data-sh-smooth') !== 'false');

    if (reduced()) {
      document.querySelectorAll('[data-scroll-speed]').forEach(function (el) { el.removeAttribute('data-scroll-speed'); });
    }

    loco = new V.LocomotiveScroll({
      lenisOptions: {
        smoothWheel: smooth,
        lerp: 0.1,
        anchors: true,
        prevent: function (node) { return !!(node && node.closest && node.closest(PREVENT)); }
      }
    });

    watchThemeScrollLock();
    window.addEventListener('load', function () { loco && loco.resize(); }, { once: true });
  }

  // Prestige locks the page while drawers and modals are open. Pause Lenis at the
  // same time so the wheel doesn't scroll the page behind an open cart drawer.
  function watchThemeScrollLock() {
    if (!loco || !loco.lenisInstance) return;
    var LOCK_CLASSES = ['lock-all', 'lock-layout', 'overflow-hidden', 'no-scroll', 'is-locked'];
    var locked = false;

    function isLocked() {
      var b = document.body;
      if (!b) return false;
      if (b.style.overflow === 'hidden' || html.style.overflow === 'hidden') return true;
      for (var i = 0; i < LOCK_CLASSES.length; i++) {
        if (html.classList.contains(LOCK_CLASSES[i]) || b.classList.contains(LOCK_CLASSES[i])) return true;
      }
      return document.querySelector('dialog[open], x-drawer[open], x-modal[open], cart-drawer[open]') !== null;
    }
    function check() {
      var now = isLocked();
      if (now === locked) return;
      locked = now;
      pauseScroll(locked);
    }
    var mo = new MutationObserver(check);
    mo.observe(html, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
  }

  /* ---------------- Category reveal (one orchestrated moment) ---------------- */

  function initReveal(el, opts) {
    if (el.__shInit) return;
    el.__shInit = true;
    var V = vendor();
    var items = el.querySelectorAll('[data-sh-reveal-item]');

    if (!V || reduced() || (opts && opts.instant) || !('IntersectionObserver' in window)) {
      el.classList.add('is-revealed');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      var a = V.anime;
      a({
        targets: items,
        clipPath: ['inset(0% 0% 100% 0%)', 'inset(0% 0% 0% 0%)'],
        duration: 1100,
        delay: a.stagger(90),
        easing: 'easeInOutQuart',
        complete: function () {
          el.classList.add('is-revealed');
          items.forEach(function (n) { n.style.clipPath = ''; });
        }
      });
      a({
        targets: el.querySelectorAll('.sh-cat__img'),
        scale: [1.18, 1],
        duration: 1600,
        delay: a.stagger(90),
        easing: 'easeOutCubic',
        complete: function (anim) {
          anim.animatables.forEach(function (x) { x.target.style.transform = ''; });
        }
      });
    }, { threshold: 0.15 });
    io.observe(el);

    // Never leave tiles hidden if something goes wrong
    setTimeout(function () { if (!el.classList.contains('is-revealed') && el.getBoundingClientRect().top < innerHeight) el.classList.add('is-revealed'); }, 4000);
  }

  /* ---------------- Projects gallery ---------------- */

  function initProjects(el) {
    if (el.__shInit) return;
    el.__shInit = true;

    var dialog = el.querySelector('.sh-lightbox');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var stage = dialog.querySelector('[data-sh-lb-stage]');
    var titleEl = dialog.querySelector('[data-sh-lb-title]');
    var countEl = dialog.querySelector('[data-sh-lb-count]');
    var imgs = [], index = 0, opener = null;

    function show(i, dir) {
      if (!imgs.length) return;
      index = (i + imgs.length) % imgs.length;
      var next = imgs[index];
      var V = vendor();
      stage.replaceChildren(next);
      countEl.textContent = (index + 1) + ' / ' + imgs.length;
      if (V && !reduced()) {
        V.anime({ targets: next, opacity: [0, 1], translateX: [dir ? 24 * dir : 0, 0], duration: 450, easing: 'easeOutCubic' });
      }
    }
    function open(btn) {
      var item = btn.closest('.sh-project');
      var tpl = item && item.querySelector('template[data-sh-gallery]');
      if (!tpl) return;
      imgs = Array.prototype.slice.call(tpl.content.cloneNode(true).querySelectorAll('img'));
      imgs.forEach(function (im) { im.loading = 'eager'; });
      var name = item.querySelector('.sh-project__name');
      var place = item.querySelector('.sh-project__place');
      titleEl.textContent = (name ? name.textContent : '') + (place ? ', ' + place.textContent : '');
      opener = btn;
      dialog.showModal();
      pauseScroll(true);
      show(0, 0);
    }
    function close() { dialog.close(); }

    el.querySelectorAll('[data-sh-gallery-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { open(btn); });
    });
    dialog.querySelector('[data-sh-lb-close]').addEventListener('click', close);
    dialog.querySelector('[data-sh-lb-prev]').addEventListener('click', function () { show(index - 1, -1); });
    dialog.querySelector('[data-sh-lb-next]').addEventListener('click', function () { show(index + 1, 1); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(index + 1, 1);
      if (e.key === 'ArrowLeft') show(index - 1, -1);
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () {
      pauseScroll(false);
      stage.replaceChildren();
      if (opener) opener.focus();
    });
    // swipe on touch screens
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      x0 = null;
    });
  }

  /* ---------------- Rails (reviews, product carousel) ---------------- */

  function initRail(el) {
    if (el.__shInit) return;
    el.__shInit = true;
    var rail = el.querySelector('[data-sh-rail-track]') || el.querySelector('.sh-rail');
    var prev = el.querySelector('[data-sh-prev]');
    var next = el.querySelector('[data-sh-next]');
    if (!rail) return;

    function step() {
      var item = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      if (!item) return rail.clientWidth * 0.8;
      var w = item.getBoundingClientRect().width + gap;
      // product carousel moves a few items at a time; reviews move one card
      return rail.hasAttribute('data-sh-rail-track') ? w * Math.max(1, Math.floor(rail.clientWidth / w) - 2) : w;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    var behavior = reduced() ? 'auto' : 'smooth';
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: behavior }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: behavior }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------------- Boot ---------------- */

  function initWithin(root, opts) {
    root.querySelectorAll('[data-sh-reveal]').forEach(function (el) { initReveal(el, opts); });
    root.querySelectorAll('[data-sh-projects]').forEach(initProjects);
    root.querySelectorAll('[data-sh-rail]').forEach(initRail);
  }

  function boot() {
    initScroll();
    initWithin(document, { instant: designMode });
    // If the vendor bundle failed to load, never leave anything hidden
    setTimeout(function () {
      if (!vendor()) document.querySelectorAll('[data-sh-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
    }, 2500);
  }

  // Theme editor: re-run a section when it's edited or re-ordered
  document.addEventListener('shopify:section:load', function (e) {
    initWithin(e.target, { instant: true });
    if (loco) { loco.addScrollElements(e.target); loco.resize(); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (loco) loco.removeScrollElements(e.target);
  });
  document.addEventListener('shopify:section:reorder', function () { if (loco) loco.resize(); });

  window.SHShowroom = { get scroll() { return loco; }, init: initWithin };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
